export var ENTITY_TYPES;
(function (ENTITY_TYPES) {
    ENTITY_TYPES["BOOKING"] = "Booking";
    ENTITY_TYPES["CLINICAL_CONDITION"] = "ClinicalCondition";
    ENTITY_TYPES["DATA_MANAGEMENT_BUILDER_FIELD"] = "DataManagementBuilderField";
    ENTITY_TYPES["FUNDING"] = "Funding";
    ENTITY_TYPES["MANAGER"] = "Manager";
    ENTITY_TYPES["RESPONDENT"] = "Respondent";
    ENTITY_TYPES["RESPONDENT_CONTACT"] = "RespondentContact";
    ENTITY_TYPES["RESPONDENT_NOTE"] = "RespondentNote";
    ENTITY_TYPES["SERVICE"] = "Service";
    ENTITY_TYPES["SUBSCRIBER"] = "Subscriber";
    ENTITY_TYPES["SURVEY"] = "Survey";
    ENTITY_TYPES["SURVEY_TYPE"] = "SurveyType";
    ENTITY_TYPES["SURVEY_ANSWER"] = "SurveyAnswer";
    ENTITY_TYPES["TEMPLATE"] = "Template";
    ENTITY_TYPES["UPLOAD"] = "Upload";
    ENTITY_TYPES["CASE"] = "Case";
})(ENTITY_TYPES || (ENTITY_TYPES = {}));
//# sourceMappingURL=entity.js.map